module.exports = __webpack_public_path__ + "static/media/PROTECCION_PERSONAL.ff4f725d.jpg";